import { updateUserLanguage, getUserProfile, updateUser } from '@/api'
import { UserProfile } from '@/types/user-profile'
import { useInvalidateOnSuccessMutation } from '@/utils'
import { useQuery, UseQueryOptions } from 'react-query'

const keys: Record<string, string> = {
  users: 'users',
  user: 'user',
  profile: 'profile',
}

const transform = ({ name, surname, ...rest }: UserProfile) => ({
  fullname: `${name} ${surname}`,
  name,
  surname,
  ...rest,
})

export const useUserProfile = (options?: UseQueryOptions<UserProfile>) =>
  useQuery<UserProfile>(keys.profile, () => getUserProfile(), {
    ...options,
    cacheTime: 0,
    select: transform,
  })

export const useUpdateUser = (id: string) =>
  useInvalidateOnSuccessMutation<UserProfile>(
    [keys],
    ({ name, surname, phone }) => updateUser(id, { name, surname, phone }),
  )

export const useUpdateUserLanguage = (id: string) =>
  useInvalidateOnSuccessMutation([keys], ({ language }) =>
    updateUserLanguage(id, { language }),
  )
